export default __webpack_public_path__ + "static/avatar-kayi-common-1-6bdecfbce173720cc0aac8f5f465e07d.png";